const QUIET_LINK_TEST_SOURCE = "prod-smoke";

export function normalizeLinkTestSource(value = "") {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === QUIET_LINK_TEST_SOURCE) {
    return normalized;
  }
  return null;
}

export function getLinkTestSourceFromSearch(search = "") {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  return normalizeLinkTestSource(params.get("test"));
}
